export const PRESET_BACKGROUNDS = [
  { id: 'grad-tikab',   label: 'Tikab Orange',  css: 'linear-gradient(135deg,#FF6B00 0%,#cc4400 100%)' },
  { id: 'grad-night',   label: 'Natt',           css: 'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)' },
  { id: 'grad-ocean',   label: 'Ocean',          css: 'linear-gradient(135deg,#0ea5e9 0%,#1565C0 100%)' },
  { id: 'grad-forest',  label: 'Skog',           css: 'linear-gradient(135deg,#064e3b 0%,#059669 100%)' },
  { id: 'grad-purple',  label: 'Lila',           css: 'linear-gradient(135deg,#4c1d95 0%,#7c3aed 100%)' },
  { id: 'grad-sunset',  label: 'Solnedgång',     css: 'linear-gradient(135deg,#ea580c 0%,#db2777 100%)' },
  { id: 'grad-steel',   label: 'Stål',           css: 'linear-gradient(135deg,#1e293b 0%,#334155 100%)' },
  { id: 'grad-gold',    label: 'Guld',           css: 'linear-gradient(135deg,#78350f 0%,#d97706 100%)' },
  { id: 'solid-black',  label: 'Svart',          css: '#111111' },
  { id: 'solid-white',  label: 'Vit',            css: '#ffffff' },
];
